module.exports = __webpack_public_path__ + "static/media/solar-eclipse.6a0f3324.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/solar-eclipse.jpg
// module id = 104
// module chunks = 0